<template>

  <div class="eol-container-box">

    <a-button type="link" class="back-class-btn" @click="$router.push(`/${school_code}/school/hsjr/class`)">{{ btnTxt}}</a-button>
    <div class="submit-tab">
      <div class="tab-item" :class="{active: activeId == 1}" @click="toLink1">已提交</div>
      <div class="tab-item" :class="{active: activeId == 2}" @click="toLink2">未提交</div>
    </div>
    <router-view></router-view>

  </div>

</template>
<script>
export default {
  data() {
    return {
      school_code: localStorage.getItem("schoolCode"),
      btnTxt: '< 返回实践班级',
      cid: "",
      activeId: 1,
    }
  },
  created() {
    this.cid = this.$route.query.cid;
    this.activeId = this.$route.query.activeInd
  },
  methods: {
    toLink1() {
      this.activeId = 1;
      this.$router.push(`/${this.school_code}/school/hsjr/SubmitRes/submited?cid=${this.cid}&activeInd=1`)
    },
    toLink2() {
      this.activeId = 2
      this.$router.push(`/${this.school_code}/school/hsjr/SubmitRes/unSubmitted?cid=${this.cid}&activeInd=2`)
    }
  }

}

</script>

<style lang="less" scoped>
.back-class-btn {
  padding: 0 16px;
  height: 32px;
  background: #b84b3c;
  border-radius: 16px;
  font-weight: bold;
  font-size: 14px;
  color: #ffffff;
  text-align: center;
  margin-bottom: 15px;
  line-height: 32px;
  &:hover {
    background: #a82822;
  }
}
.delete-modal {
  font-weight: bold;
  font-size: 16px;
  color: #373536;
  text-align: center;
}
.choose-modal {
  padding-top: 20px;
}
.submit-tab {
  border-bottom: #d3d3d3 1px solid;
  display: flex;
  margin-bottom: 10px;
  .tab-item {
    color: #373536;
    padding-bottom: 10px;
    margin-right: 20px;
    cursor: pointer;
    font-size: 16px;
    &.active {
      color: #b84b3c;
      font-weight: bold;
      position: relative;
      &::before {
        content: "";
        display: block;
        width: 100%;
        height: 2px;
        position: absolute;
        background-color: #b84b3c;
        bottom: -1px;
      }
    }
  }
}
</style>